<template>
  <div
    class="additional-details-highlight"
    v-html="keywordHighlightHtml"
  />
</template>

<script>
import { buildKeywordHighlightHtml } from "@/vue/utils/consultationKeywordHighlight";

export default {
  name: "AdditionalDetailsHighlightedWithKeywords",
  props: {
    keywords: {
      type: Array,
      default: () => [],
    },
    additionalDetails: {
      type: String,
      default: "",
    },
  },
  computed: {
    keywordHighlightHtml() {
      return buildKeywordHighlightHtml(this.additionalDetails, this.keywords);
    },
  },
};
</script>

<style lang="scss">
.additional-details-highlight {
  line-height: 2.0;

  em {
    background-color: rgba(255, 255, 0, 0.4);
    font-style: normal;
    font-weight: bold;
  }
}
</style>
